export default __webpack_public_path__ + "static/media/ganeshji.253d523e.jpg";